const axios = require('axios')

function login(mail, password) {
    return axios.post('/api/user/token', { 'mail': mail, 'password': password })
}

function validarLogin(matricula, senha) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*'
    }

    var params = new URLSearchParams();
    params.append('token', process.env.REACT_APP_USER_TOKEN);
    params.append('type', 'login');
    params.append('q', matricula);
    params.append('q2', window.btoa(senha));    

    return axios({
        method: 'get',
        url: 'https://ws.clamed.com.br:8080/sincroniza.php',        
        params: params,
        headers: headers
    });
}

function verify(token) {
    return axios.post('/api/user/verify', { 'token': token })
}

function register(name, mail, password) {
    return axios.post('/api/user/register', { 'name': name, 'mail': mail, 'password': password, type: 2 })
}

function resendConfirmation(mail) {
    return axios.post('/api/user/resendConfirmation', { 'mail': mail })
}

module.exports = { login, register, resendConfirmation, verify, validarLogin }